import React from "react";
import { Link } from "react-router-dom";
import logoLight from "../assets/images/rangabandiweb.png";
import {
  FiFacebook,
  FiYoutube,
  FiInstagram,
  FiTwitter,
  FiMail,
  FiPhone,
  FiMapPin,
} from "../assets/icons/vander";

export default function Footer() {
  return (
    <>
      <footer
        style={{ backgroundColor: "#f3fbe8", borderTop: "2px solid #8B3C32" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-5 col-lg-4 mb-0 mb-md-4 pb-0 pb-md-2">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Link to="#" className="logo-footer">
                  <img src={logoLight} height="75" alt="" />
                </Link>
              </div>

              <p
                className="mt-4 me-xl-5"
                style={{ color: "#726e6e", textAlign: "justify" }}
              >
                Rangabandi celebrates the vibrant essence of Indian theatre,
                bringing diverse stories to life on stage. Our platform fosters
                creativity, connects enthusiasts, and showcases timeless and
                contemporary performances. Join us to experience the magic of
                drama and art. Let's keep the spirit of theatre alive together!
              </p>
            </div>

            <div className="col-xl-7 col-lg-8 col-md-12">
              <div className="row">
                <div
                  className="col-md-6 col-12"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <ul className="list-unstyled footer-list">
                    <h5 className="footer-head" style={{ color: "#8B3C32" }}>
                      Rangabandi
                    </h5>
                    <li>
                      <Link
                        to="/about"
                        className="text-foot"
                        style={{ color: "#726e6e" }}
                      >
                        <i className="mdi mdi-chevron-right me-1"></i> About
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/blogs"
                        className="text-foot"
                        style={{ color: "#726e6e" }}
                      >
                        <i className="mdi mdi-chevron-right me-1"></i> Blog
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/events"
                        className="text-foot"
                        style={{ color: "#726e6e" }}
                      >
                        <i className="mdi mdi-chevron-right me-1"></i> Events
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/donations"
                        className="text-foot"
                        style={{ color: "#726e6e" }}
                      >
                        <i className="mdi mdi-chevron-right me-1"></i> Donations
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/gallery-photos"
                        className="text-foot"
                        style={{ color: "#726e6e" }}
                      >
                        <i className="mdi mdi-chevron-right me-1"></i> Gallery
                        Images
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/gallery-videos"
                        className="text-foot"
                        style={{ color: "#726e6e" }}
                      >
                        <i className="mdi mdi-chevron-right me-1"></i> Gallery
                        videos
                      </Link>
                    </li>
                  </ul>
                </div>

                <div
                  className="col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <ul className="list-unstyled footer-list">
                    <h5 className="footer-head" style={{ color: "#8B3C32" }}>
                      Contact us
                    </h5>
                    <li className="d-flex align-items-center">
                      <FiMail
                        style={{ color: "#8B3C32" }}
                        className="fea icon-sm text-foot align-middle"
                      />
                      <Link
                        to="mailto:rangabandimalavalli@gmail.com"
                        className="text-foot ms-2"
                        style={{ color: "#726e6e" }}
                      >
                        rangabandimalavalli@gmail.com
                      </Link>
                    </li>

                    <li className="d-flex align-items-center">
                      <FiPhone
                        style={{ color: "#8B3C32" }}
                        className="fea icon-sm text-foot align-middle"
                      />
                      <Link
                        to="tel:+91 70229 40964"
                        className="text-foot ms-2"
                        style={{ color: "#726e6e" }}
                      >
                        +91 70229 40964
                      </Link>
                    </li>

                    <li className="d-flex align-items-center">
                      <FiMapPin
                        style={{ color: "#8B3C32" }}
                        className="fea icon-sm text-foot align-middle"
                      />
                      <Link
                        to="https://www.google.com/maps/dir//Malavalli+Karnataka/@12.3853432,77.0535798,19725m/data=!3m1!1e3!4m8!4m7!1m0!1m5!1m1!1s0x3baf05cae86fa1ff:0xd8f8578376ddb9dc!2m2!1d77.0535798!2d12.3853432?entry=ttu&g_ep=EgoyMDI0MTIwMi4wIKXMDSoASAFQAw%3D%3D"
                        target="_blank"
                        className="video-play-icon text-foot ms-2"
                        style={{ color: "#726e6e" }}
                      >
                        View on Google map
                      </Link>
                    </li>

                    <ul className="list-unstyled social-icon footer-social mb-0 mt-4">
                      <li className="list-inline-item">
                        <Link
                          to="https://www.facebook.com/share/4CJxXJmqQpj3conc/?mibextid=LQQJ4d"
                          target="_blank"
                          className="rounded-pill"
                        >
                          <FiFacebook
                            style={{ color: "#8B3C32" }}
                            className="fea icon-sm fea-social"
                          />
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          to="https://www.instagram.com/rangabandimalavalli/?igsh=MWZzaDZ5emU4aTFwdw%3D%3D&utm_source=qr"
                          target="_blank"
                          className="rounded-pill"
                        >
                          <FiInstagram
                            style={{ color: "#8B3C32" }}
                            className="fea icon-sm fea-social"
                          />
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          to="https://www.youtube.com/@RangabandiMalavalli"
                          target="_blank"
                          className="rounded-pill"
                        >
                          <FiYoutube
                            style={{ color: "#8B3C32" }}
                            className="fea icon-sm fea-social"
                          />
                        </Link>
                      </li>
                    </ul>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="container mt-5"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div className="pt-4 footer-bar">
            <div className="text-sm-start text-center">
              <p className="mb-0" style={{ color: "#726e6e" }}>
                {new Date().getFullYear()}© Design & Develop by sdsd{" "}
                <Link
                  to="https://c2m-edutech.com"
                  target="_blank"
                  className="text-reset"
                >
                  <b>C2M Edutech Solutions Ltd</b>
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
